/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillsControllerRemoveMutationResponse, SkillsControllerRemovePathParams } from "../../models/skillsController/SkillsControllerRemove";

function getSkillsControllerRemoveUrl(id: SkillsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/skills/${id}` as const }  
  return res
}

/**
 * @summary Archive a skill
 * {@link /api/v1/skills/:id}
 */
export async function skillsControllerRemove(id: SkillsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SkillsControllerRemoveMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getSkillsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}